module.exports = __webpack_public_path__ + "img/ic_clubhouse.822faa72.png";